<template>
    <div><!--ini -->

    <h3><b>api nivel</b></h3>
    {{api_mant_nivel}}
    <br><br>

    <h3><b>api Grado</b></h3>
    {{api_mant_nivel}}
    <br><br>

    <h3><b>api Areas</b></h3>
    {{api_mant_nivel}}
    <br><br>

    <h3><b>api Cursos</b></h3>
    {{api_mant_nivel}}
    <br><br>

    <h3><b>api Temas</b></h3>
    {{api_mant_nivel}}
    <br><br>


<v-row>
  <v-col cols="3 b">

   <!-- -->
<template>
  <v-treeview
    v-model="tree"
    :open="open"
    :items="items"
    activatable
    item-key="name"
    open-on-click
  >
    <template v-slot:prepend="{ item, open }">
      <v-icon v-if="!item.file">
        {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
      </v-icon>
      <v-icon v-else>
        {{ files[item.file] }}
      </v-icon>
    </template>
  </v-treeview>
</template>
      <!-- -->

      <!-- -->
<!-- <template>
  <v-treeview
    selectable
    selected-color="green"
    :items="items"
  ></v-treeview>
</template> -->
      <!-- -->

  </v-col>
  <v-col cols="9 d">

  </v-col>
</v-row>

<!-- --><pre></pre>
    </div><!--end -->
</template>

<script>
import axios from "../helpers/axios";

    export default {
        name: 'visordecontenido',
        data(){
            return{

            selecopnivel:{
            id:0,
            desc_nivel:'',
            id_colegio:0,
            ck1: false,
            },

            api_mant_nivel:[],

        open: ['public'],
        files: {
        html: 'mdi-language-html5',
        js: 'mdi-nodejs',
        json: 'mdi-json',
        md: 'mdi-markdown',
        pdf: 'mdi-file-pdf',
        png: 'mdi-file-image',
        txt: 'mdi-file-document-outline',
        xls: 'mdi-file-excel',
      },
      tree: [],
      items: [

        {
          name: 'Nivel',
          children: [{
                name: '1',
                file: 'png',
              }],
        },

        {
          name: 'Grado',
          children: [{
                name: '2',
                file: 'png',
              }],
        },

         {
          name: 'Areas',
          children: [{
                name: '2',
                file: 'png',
              }],
        },

         {
          name: 'Cursos',
          children: [{
                name: '2',
                file: 'png',
              }],
        },


        // {
        //   name: 'public',
        //   children: [

        //     {
        //       name: 'favicon.ico',
        //       file: 'png',
        //     },
        //     {
        //       name: 'index.html',
        //       file: 'html',
        //     },
        //   ],
        // },

        // {
        //   name: '.gitignore',
        //   file: 'txt',
        // },
        // {
        //   name: 'babel.config.js',
        //   file: 'js',
        // },
        // {
        //   name: 'package.json',
        //   file: 'json',
        // },



      ],

            }

        },



         mounted() {
             this.selopnivel()
        },

         methods:{

            selopnivel(){
              axios.get('/mantenimiento/nivelCkOne',{

            })
            .then( response => {
            console.log(response)
            this.api_mant_nivel = response.data  })
            .catch( e=> console.log(e))
    },

        },
    }
</script>

<style scoped>

.a{
    background-color: brown;
}
.b{
    background-color: coral;
}
.c{
    background-color: blueviolet;
}
.d{
    background-color: rgb(45, 67, 167);
}

</style>